import script from "./OverspeedSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./OverspeedSettings.vue?vue&type=script&setup=true&lang=js"

import "./OverspeedSettings.vue?vue&type=style&index=0&id=ea7da97a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea7da97a"]])

export default __exports__